export const COUNTER = 'person-counter';
